<template>
  <div class="nights-single-flight-info-component items-center space-x-1 md:space-x-3">
    <div class="flight">
      <p class="grow text-sm md:text-xl text-black font-black mb-2">
        {{  datetime('Departure') | time }}
      </p>
      <p>
        ({{cityFrom}})
      </p>
    </div>
    <div class="duration color-brown-grey flex-grow">
      <p class="text-black">{{ showHours(flight.totalDuration) }}</p>
      <hr class="mx-auto border-t border-dashed border-semiDarkgrey h-0 w-full my-1" />
      <p class="text-black">{{ $tc('shared.stopOvers', stopOvers) }}</p>
    </div>
    <div class="flight pr-5 w-fit">
      <div class="flex relative">
        <p class="grow text-sm md:text-xl text-black font-black mb-2">
          {{ datetime('Arrival') | time }}
        </p>
        <sup v-if="isNextDay" class="absolute right-[-17px] lg:right-[-20px] top-[-1px] lg:top-[-3px] text-xs lg:text-[12px]">+1</sup>
      </div>
      <p>
        ({{cityTo}})
      </p>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import moment from 'moment';
import { locationHasTimezoneDiff, minutesToHoursMinutes } from '../helpers';

export default {
  props: {
    direction: {
      type: String,
      validator: function (value) {
        return ['journey', 'return'].includes(value);
      }
    },
    flight: {
      type: Object,
      required: true,
    },
    price: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    timezoneDiff() {
      if (locationHasTimezoneDiff(this.destination)) {
        return +1;
      }
      if (locationHasTimezoneDiff(this.origin)) {
        return -1;
      }
      return 0;
    },
    cityFrom() {
      return this.direction === 'journey' ? this.flight.cityCodeFrom : this.flight.cityCodeTo
    },
    cityTo() {
      return this.direction === 'journey' ? this.flight.cityCodeTo : this.flight.cityCodeFrom
    },
    stopOvers() {
      return this.direction === 'journey' ? this.flight.journeyStopOvers : this.flight.returnStopOvers
    },
    departureTime() {
        return this.flight[`${this.direction}FlightDepartureTime`];
    },
    arrivalTime() {
      return this.flight[`${this.direction}FlightArrivalTime`];
    },
    isNextDay() {
      const departure = moment(this.departureTime);
      const arrival = moment(this.arrivalTime).add(this.timezoneDiff, 'hours');
      const departureDay = departure.dayOfYear();
      const arrivalDay = arrival.dayOfYear();
      return arrivalDay > departureDay;
    }
  },
  methods: {
    datetime(type) {
      return this.flight[`${this.direction}Flight${type}Time`];
    },
    name(type) {
      const { name, code } = this.$store.state.nights[type];
      return `${name} (${code})`;
    },
    showHours(minutes) {
      return minutesToHoursMinutes(minutes)
    }
  }
}
</script>

<style scoped lang="scss">
.nights-single-flight-info-component {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1.25fr;
  gap: 0.5rem;

  @media(max-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr

  }

  > div {
    overflow: hidden;
  }

  p {
    overflow-wrap: break-word;
    text-align: center;
    line-height: 1.25;
  }

  .flight {
    display: flex;
    flex-direction: column;
    align-self: stretch;
  }

  .duration {
    align-self: center;
  }
}

</style>
